import React from "react";
import { Header, Icon, Segment, Sidebar } from "semantic-ui-react";
import "./SidebarWithHeader.scss";

interface ISidebarWithHeader {
  headerText: string;
  visible: boolean;
  closeSidebar: Function;
  children: any; // content inside of the sidebar
}

const SidebarWithHeader = ({ headerText, visible, closeSidebar, children }: ISidebarWithHeader) => {
  return (
    <Sidebar
      animation='overlay'
      direction='right'
      visible={visible}
      className='filterSidebar'
      onHide={() => closeSidebar()}
    >
      {/* header */}
      <Segment className='sidebarHeader'>
        <div className='tw-flex tw-items-center'>
          <Icon className='button-icon' name='close' size='large' onClick={() => closeSidebar()} />
          <Header as='h3'> {headerText} </Header>
        </div>
      </Segment>

      {/* content */}
      {children}
    </Sidebar>
  );
};

export default SidebarWithHeader;
